(() => {
  if (customElements.get('cards-carousel')) {
    return;
  }

  class CardsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.initSlider();
      this.attachEvents();
    }

    attachEvents() {
      this.debouncedOnResize = debounce(() => {
        const isMobileDevices = window.matchMedia(
          this.mobileBreakpoint,
        ).matches;

        if (
          (isMobileDevices && this.sliderType === 'mobile') ||
          (!isMobileDevices && this.sliderType === 'desktop')
        ) {
          return;
        }

        this.destroySlider();

        this.initSlider();
      }, 100);

      window.addEventListener('resize', this.debouncedOnResize.bind(this));
    }

    initElements() {
      this.mobileBreakpoint = '(max-width: 749px)';
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: this.querySelector('[data-pagination]'),
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
        },
        keyboard: true,
        slidesPerView: 'auto',
        grid: {
          rows: this.dataset.gridRows || 1,
        },
        spaceBetween: 8,
        breakpoints: {
          750: {
            spaceBetween: 20,
          },
        },
      };
      this.sliderType = '';
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      this.options.centeredSlides = isMobileDevices ? true : false;

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );

      this.sliderType = isMobileDevices ? 'mobile' : 'desktop';
    }

    destroySlider() {
      this.slider.destroy();

      this.slider = null;
    }

    updateSlider() {
      this.slider.update();
    }

    removeSlide(index) {
      this.slider.removeSlide(index);
    }
  }

  customElements.define('cards-carousel', CardsCarousel);
})();
